import { useEffect } from 'react';

import { useGetCmsAndLoyaltyOffers } from 'pages/loyalty/loyalty-offers/use-get-cms-and-loyalty-offers';
import { UseReduceOffersProps } from 'pages/loyalty/loyalty-offers/use-offers-reducer';
import { selectors, useAppSelector } from 'state/global-state';

/**
 * Refresh offers when shouldRefetchOffers is true.
 * If skip is true, the refresh will not be triggered.
 * @param skip - If true, the refresh will not be triggered.
 */
export const useRefreshOffers = ({ skip }: { skip?: boolean }) => {
  const shouldRefetchOffers = useAppSelector(selectors.loyalty.selectShouldRefetchOffers);
  const { refreshOffers, ...rest } = useGetCmsAndLoyaltyOffers();

  // TODO: investigate is it safe to use useEffect here?
  useEffect(() => {
    if (!skip && shouldRefetchOffers) {
      refreshOffers();
    }
  }, [refreshOffers, skip, shouldRefetchOffers]);

  return rest as UseReduceOffersProps;
};
